import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { Injectable } from "@angular/core";

import { IApiRequest, IApiresponse } from "src/app/_models";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import {
  CategorySummaryResponse,
  CloseProjectRequest,
  CostCentreCustomerList,
  GetActiveEmployeesForProjectBudgetRequest,
  GetActiveEmployeesForProjectBudgetResponse,
  GetCustomerCostCentreListRequest,
  GetProjectBudgetAllDetailsByProgBudIdRequest,
  GetProjectBudgetByEntityTypeRequest,
  GetProjectListForCloseResponse,
  GetProjectManagerCountRequest,
  IProjectBudgetListRequest,
  IProjectBudgetListResponse,
  ProjectBudgetForEntity,
  ProjectBudgetResponse,
  ProjectCategorySummaryRequest,
  ProjectManagerDetails,
  ProjectSummaryRequest,
  ProjectSummaryResponse,
  UpdateProjectManagerRequest,
  IGetCustomerCostCentreProjectsListRequest,
  ICostCentreCustomerProjectListResponse,
  IEntityDetailsListResponse,
  ICheckEntityExistsResponse,
  IAvailableEntityListResponse,
  IEntityConfigDetails,
  IAvailableApproverListResponse,
  IEntitySaveDetailsRequest,
  ISaveItemDetailsResponse,
  IProjectDetailByEntityRequest,
  EntityDetailsForProjectsResponse,
  ProjectDetailsList,
  IEntityDetailsForProjectsResponse,
  ISaveApprovalRuleRequest,
  ISaveApprovalRuleResponse,
  IProjectConfigDetails,
  IProjectDetailRequest,
  IProjectsSaveDetailsRequest,
  IBulkBillableStatusRequest,
  IProjectsDetailsForExpenseCategoryResponse,
  IAvailableEmailRecipientListResponse,
  IBulkCategoriesSaveDetailsRequest,
  ISaveBulkCategorieDetailsResponse,
  IGetProjectEntitiesRequest,
  IProjectsEntitiesClaimantMapping,
  ISaveEntityProjectClaimantMappingRequest,
  IGenericResponse,
  IActiveClaimantListResponse,
  IEntityDashboardRequest,
  IEntityDashboardDetails,
  IGetEntitiesForImportRequest,
  IEntitiesForImportResponse,
  IGetProjectsForImportRequest,
  IProjectsForImportResponse,
  IRerouteProjectAndBudgetExpensesResponse,
  IRerouteProjectAndBudgetExpensesRequest,
  IPBPendingExpenseCountResponse,
} from "src/app/_models/project-budget/project-budget";

@Injectable({
  providedIn: "root",
})
export class ProjectBudgetService {
  httpHeaders: HttpHeaders;
  constructor(
    private http: HttpClient,
    private claimsHeaderService: ClaimsHeaderService
  ) { }

  GetProjectBudgetList(
    requestInfo: IApiRequest<IProjectBudgetListRequest>
  ): Observable<IApiresponse<IProjectBudgetListResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IProjectBudgetListResponse>>(
      `${environment.billingApiUrl}GetProjectBudgetList`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectSummary(
    requestInfo: IApiRequest<ProjectSummaryRequest>
  ): Observable<IApiresponse<ProjectSummaryResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ProjectSummaryResponse>>(
      `${environment.billingApiUrl}GetProjectSummary`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetCustomerCostCentreList(
    requestInfo: IApiRequest<GetCustomerCostCentreListRequest>
  ): Observable<IApiresponse<CostCentreCustomerList[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<CostCentreCustomerList[]>>(
      `${environment.billingApiUrl}GetCustomerCostCentreList`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetActiveEmployeesForProjectBudget(
    requestInfo: IApiRequest<GetActiveEmployeesForProjectBudgetRequest>
  ): Observable<IApiresponse<GetActiveEmployeesForProjectBudgetResponse[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<
      IApiresponse<GetActiveEmployeesForProjectBudgetResponse[]>
    >(`${environment.billingApiUrl}GetActiveEmployeesForProjectBudget`, body, {
      headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
    });
  }
  
  SaveProjectBudget(
    requestInfo: IApiRequest<any>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}AddEditProjectBudget`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  
  GetProjectBudgetAllDetailsByProjectBudgetId(
    requestInfo: IApiRequest<GetProjectBudgetAllDetailsByProgBudIdRequest>
  ): Observable<IApiresponse<ProjectBudgetResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ProjectBudgetResponse>>(
      `${environment.billingApiUrl}GetProjectBudgetAllDetailsByProjectBudgetId`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectCategorySummaryResponse(
    requestInfo: IApiRequest<ProjectCategorySummaryRequest>
  ): Observable<IApiresponse<CategorySummaryResponse[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<CategorySummaryResponse[]>>(
      `${environment.billingApiUrl}GetProjectCategorySummaryResponse`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectBudgetByEntityType(
    requestInfo: IApiRequest<GetProjectBudgetByEntityTypeRequest>
  ): Observable<IApiresponse<ProjectBudgetForEntity[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ProjectBudgetForEntity[]>>(
      `${environment.billingApiUrl}GetProjectBudgetByEntityType`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectManagerCount(
    requestInfo: IApiRequest<GetProjectManagerCountRequest>
  ): Observable<IApiresponse<ProjectManagerDetails[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ProjectManagerDetails[]>>(
      `${environment.billingApiUrl}GetProjectManagerCount`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  UpdateProjectManagerWhenApproverDeactivate(
    requestInfo: IApiRequest<UpdateProjectManagerRequest>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}UpdateProjectManagerWhenApproverDeactivate`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectListForClose(
    requestInfo: IApiRequest<IProjectBudgetListRequest>
  ): Observable<IApiresponse<GetProjectListForCloseResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<GetProjectListForCloseResponse>>(
      `${environment.billingApiUrl}GetProjectListForClose`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  CloseProject(
    requestInfo: IApiRequest<CloseProjectRequest>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}CloseProject`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetCustomerCostCentreProjectList(
    requestInfo: IApiRequest<IGetCustomerCostCentreProjectsListRequest>
  ): Observable<IApiresponse<ICostCentreCustomerProjectListResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ICostCentreCustomerProjectListResponse>>(
      `${environment.billingApiUrl}GetCustomerCostCentreProjectListNew`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }


  // NEW CODE P&B ******************
  GetDashboardDetails(
  ): Observable<IApiresponse<IEntityDetailsListResponse>> {
    return this.http.get<IApiresponse<IEntityDetailsListResponse>>(
      `${environment.billingApiUrl}GetEntityDetailsList`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  CheckEntityExists(): Observable<IApiresponse<ICheckEntityExistsResponse>> {
    return this.http.get<IApiresponse<ICheckEntityExistsResponse>>(
      `${environment.billingApiUrl}CheckEntityExists`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetAvailableEntityList(): Observable<IApiresponse<IAvailableEntityListResponse>> {
    return this.http.get<IApiresponse<IAvailableEntityListResponse>>(
      `${environment.billingApiUrl}GetAvailableEntityList`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetEntityDetails(entityId: number): Observable<IApiresponse<IEntityConfigDetails>> {
    const params = new HttpParams().set('entityId', entityId.toString());
    return this.http.get<IApiresponse<IEntityConfigDetails>>(
      `${environment.billingApiUrl}GetEntityDetails`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader(), params }
    );
  }

  GetAvailableApproverList(): Observable<IApiresponse<IAvailableApproverListResponse>> {
    return this.http.get<IApiresponse<IAvailableApproverListResponse>>(
      `${environment.billingApiUrl}GetAvailableApproverList`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveEntityDetails(requestInfo: IApiRequest<IEntitySaveDetailsRequest>): Observable<IApiresponse<ISaveItemDetailsResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ISaveItemDetailsResponse>>(
      `${environment.billingApiUrl}SaveEntityDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetEntityDetailsForProject(requestInfo: IApiRequest<IProjectDetailByEntityRequest>): Observable<IApiresponse<IEntityDetailsForProjectsResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IEntityDetailsForProjectsResponse>>(
      `${environment.billingApiUrl}GetEntityDetailsForProject`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetAllProjectDetailsListForEntity(requestInfo: IApiRequest<IProjectDetailByEntityRequest>): Observable<IApiresponse<ProjectDetailsList>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ProjectDetailsList>>(
      `${environment.billingApiUrl}GetAllProjectDetailsListForEntity`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectsDetailsForExpenseCategory(requestInfo: IApiRequest<IProjectDetailByEntityRequest>): Observable<IApiresponse<IProjectsDetailsForExpenseCategoryResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IProjectsDetailsForExpenseCategoryResponse>>(
      `${environment.billingApiUrl}GetProjectsDetailsForExpenseCategory`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveApprovalRule(requestInfo: IApiRequest<ISaveApprovalRuleRequest>): Observable<IApiresponse<ISaveApprovalRuleResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ISaveApprovalRuleResponse>>(
      `${environment.billingApiUrl}SaveApprovalRule`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectDetails(requestInfo: IApiRequest<IProjectDetailRequest>): Observable<IApiresponse<IProjectConfigDetails>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IProjectConfigDetails>>(
      `${environment.billingApiUrl}GetProjectDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveProjectDetails(requestInfo: IApiRequest<IProjectsSaveDetailsRequest>): Observable<IApiresponse<ISaveItemDetailsResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ISaveItemDetailsResponse>>(
      `${environment.billingApiUrl}SaveProjectDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveProjectBulkBillableStatus(requestInfo: IApiRequest<IBulkBillableStatusRequest>): Observable<IApiresponse<any>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}SaveProjectBulkBillableStatus`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

    GetAvailableEmailRecipientList(): Observable<IApiresponse<IAvailableEmailRecipientListResponse>> {
    return this.http.get<IApiresponse<IAvailableEmailRecipientListResponse>>(
      `${environment.billingApiUrl}GetAvailableEmailRecipientList`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetActiveClaimantList(): Observable<IApiresponse<IActiveClaimantListResponse>> {
    return this.http.get<IApiresponse<IActiveClaimantListResponse>>(
      `${environment.billingApiUrl}GetActiveClaimantList`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveBulkCategoryDetails(requestInfo: IApiRequest<IBulkCategoriesSaveDetailsRequest>): Observable<IApiresponse<ISaveBulkCategorieDetailsResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<ISaveBulkCategorieDetailsResponse>>(
      `${environment.billingApiUrl}SaveBulkCategoryDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectEntitiesList(requestInfo: IApiRequest<IGetProjectEntitiesRequest>): Observable<IApiresponse<IProjectsEntitiesClaimantMapping>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IProjectsEntitiesClaimantMapping>>(
      `${environment.billingApiUrl}GetProjectEntitiesList`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveEntityProjectClaimantMapping(requestInfo: IApiRequest<ISaveEntityProjectClaimantMappingRequest>): Observable<IApiresponse<IGenericResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IGenericResponse>>(
      `${environment.billingApiUrl}SaveEntityProjectClaimantMapping`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  SaveEntityProjectClaimantMappingBulkForImport(requestInfo: IApiRequest<ISaveEntityProjectClaimantMappingRequest>): Observable<IApiresponse<string>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<string>>(
      `${environment.billingApiUrl}SaveEntityProjectClaimantMappingBulkForImport`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetEntityDashboardDetails(requestInfo: IApiRequest<IEntityDashboardRequest>): Observable<IApiresponse<IEntityDashboardDetails>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IEntityDashboardDetails>>(
      `${environment.billingApiUrl}GetEntityDashboardDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetEntitiesForImport(requestInfo: IApiRequest<IGetEntitiesForImportRequest>): Observable<IApiresponse<IEntitiesForImportResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IEntitiesForImportResponse>>(
      `${environment.billingApiUrl}GetEntitiesForImport`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetProjectsForImport(requestInfo: IApiRequest<IGetProjectsForImportRequest>): Observable<IApiresponse<IProjectsForImportResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IProjectsForImportResponse>>(
      `${environment.billingApiUrl}GetProjectsForImport`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

    RerouteProjectAndBudgetExpenses(requestInfo: IApiRequest<IRerouteProjectAndBudgetExpensesRequest>): Observable<IApiresponse<IRerouteProjectAndBudgetExpensesResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IRerouteProjectAndBudgetExpensesResponse>>(
      `${environment.billingApiUrl}RerouteProjectAndBudgetExpenses`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  BulkRerouteProjectAndBudgetExpenses(requestInfo: IApiRequest<IRerouteProjectAndBudgetExpensesRequest[]>): Observable<IApiresponse<IRerouteProjectAndBudgetExpensesResponse>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IRerouteProjectAndBudgetExpensesResponse>>(
      `${environment.billingApiUrl}BulkRerouteProjectAndBudgetExpenses`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetPBPendingExpenseCounts(requestInfo: IApiRequest<IRerouteProjectAndBudgetExpensesRequest[]>): Observable<IApiresponse<IPBPendingExpenseCountResponse[]>> {
    const body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<IPBPendingExpenseCountResponse[]>>(
      `${environment.expenseApiUrl}GetPBPendingExpenseCounts`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }


}
